import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";
import type { GraphqlQueryResponse } from "@Common/api/types/GraphqlQueryResponse";
import { ICommissionCycle } from "../types/CommissionCycle";
import { TreeNodeFragment } from "@/Common/fragments/GenericTree";

interface IGetCommissionCyclesFilter {
	excludeStatuses: string[];
}

export async function getCommissionCyclesTree(locationId: string) {
	const query = gql`
		query getCommissionCyclesTree($locationId: String!) {
			getCommissionCyclesTree(locationId: $locationId) {
				locationId
				tree {
					...TreeNode
					list {
						...TreeNode
					}
				}
				hints {
					defaultSelectedIds
					expandedIds
					prefetchIds
				}
			}
		}

		${TreeNodeFragment}
	`;

	const variables = { locationId };

	const response = await apiInstance.post("/graphql", { query, variables });
	return response?.data?.data?.getCommissionCyclesTree;
}

export async function getCommissionCycles(locationId: string, filter: IGetCommissionCyclesFilter = { excludeStatuses: ["STAGING"] }) {
	const query = gql`
		query getCommissionCycles($locationId: String!, $filter: CommissionCyclesFilterInput) {
			getCommissionCycles(locationId: $locationId, filter: $filter) {
				_id
				title
				status
				startDate
				endDate
				dataUpdatedAt
				payPeriods {
					_id
					title
					intervalCode
					startDate
					endDate
					inReview
					drawIngested
					nextCCId
					previousCCId
					status
					positionStatus {
						position
						status
					}
					payPeriodProviders {
						status
						providerPayPeriodId
						companyId
						displayId
					}
				}
				inFinalizingProcess
			}
		}
	`;

	const variables = {
		locationId,
		filter,
	};

	try {
		const response: GraphqlQueryResponse<"getCommissionCycles", ICommissionCycle[]> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.getCommissionCycles;
	} catch (err) {
		errorLogger(err as Error);
		return null;
	}
}
